import { render, staticRenderFns } from "./ClienteNovosSemMovimentacaoAnual.vue?vue&type=template&id=07fc468a&scoped=true&"
import script from "./ClienteNovosSemMovimentacaoAnual.vue?vue&type=script&lang=js&"
export * from "./ClienteNovosSemMovimentacaoAnual.vue?vue&type=script&lang=js&"
import style0 from "./ClienteNovosSemMovimentacaoAnual.vue?vue&type=style&index=0&id=07fc468a&scoped=true&lang=css&"
import style1 from "./ClienteNovosSemMovimentacaoAnual.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc468a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
